enum MonthlyStartDateType {
    FirstDayOfTheMonth = 'First Day of the Month',
    LastDayOfTheMonth = 'Last Day of the Month',
    CustomStartingDate = 'Custom Starting Date',
}

export default MonthlyStartDateType;
